import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWORK } from "../../../../common/constants/appRoad"
import { useRoadworksQuery } from "../../../../common/hooks/queries/useRoadworksQuery"
import { constructTechniqueAcronym } from "../../utils/roadworkUtils"

import { roadworksQueryKeys } from "./queryKeys"
import { useTaskTypes } from "./useTaskType"

export function useGetTechniquesQuery(
    queryParameters,
    config = {},
) {
    const url = "roadworks/techniques/"
    const parameters = useExtendWithSubnetworks(queryParameters, API_MODULE_ROADWORK)
    const queryKey = roadworksQueryKeys["techniques"](parameters)

    const {
        data: techniques,
        isLoading: isLoadingTechniques,
        isError: isErrorTechniques,
    } = useRoadworksQuery(
        url,
        queryKey,
        parameters,
        config,
    )

    const {
        data: taskTypes,
        isLoading: isLoadingTaskTypes,
        isError: isErrorTaskTypes,
    } = useTaskTypes()

    const isLoading = isLoadingTechniques || isLoadingTaskTypes
    const isError = isErrorTechniques || isErrorTaskTypes

    const data = techniques?.map(technique => {
        const techniqueAcronym = constructTechniqueAcronym(technique, taskTypes)
        return {
            ...technique,
            acronym: techniqueAcronym,
        }
    })

    return { data, isLoading, isError }
}